import React from 'react';
import { showDeleteConfirmModal } from './ConfirmFactory';
import { DeleteModalProps } from './types';

/**
 * Standardized button for triggering delete confirmations.
 */
export const StandardDeleteConfirmButton: React.FC<DeleteModalProps & { buttonText?: string }> = ({
  buttonText = 'Delete',
  ...props
}) => {
  const handleClick = () => {
    showDeleteConfirmModal(props);
  };

  return (
    <button onClick={handleClick} className="ant-btn ant-btn-dashed">
      {buttonText}
    </button>
  );
};
